/* eslint-disable */
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
// 引入css初始化
import './assets/css/reset.css'
import './assets/css/style.css'
// 移动端自适应
import 'lib-flexible'
import VueTitle from 'vue-wechat-title'
Vue.use(VueTitle)
/* 引入日期插件 */
import Calendar from "vue2-datepick"
Vue.use(Calendar)
// 引入微信sdk
import wx from 'weixin-js-sdk'
Vue.prototype.wx = wx
import axios from "axios"
if (location.port)
  // axios.defaults.baseURL = 'http://localhost:8089';
  // axios.defaults.baseURL = 'http://192.168.101.250:8089';
  // axios.defaults.baseURL = 'http://192.168.1.119:8089';//本地
  // axios.defaults.baseURL = 'http://cxiaoyu.cn:18089'
axios.defaults.baseURL = 'https://api.ibnsina360.com'
else
  axios.defaults.baseURL = 'https://api.ibnsina360.com'
  // axios.defaults.baseURL = 'http://localhost:8089';
// axios.defaults.timeout = 10000;
Vue.prototype.$http = axios
import qs from 'qs'
Vue.use(qs)
// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  config.headers.Authorization = "Bearer " + localStorage.getItem("token")
  if (config.qs == "no") {
    return config
  }
  config.data = qs.stringify(config.data)
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})
//在 response 拦截器实现
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // localStorage.removeItem("token")
    // localStorage.removeItem("tokenTime")
    // location.reload()
    return Promise.reject(error)
  }
)
Vue.prototype.$loading = function (msg) {
  store.state.loadingTxt = msg || '加载中'
  store.state.loadingFlag = true
}
/**
 * 通用函数 toots普通的提示，tootsSuccess带成功ICON的提示
 */
Vue.prototype.$toots = function (msg) {
  store.state.tootsTxt = msg
  store.state.tootsFlag = true
  store.state.loadingFlag = false
  setTimeout(() => {
    store.state.tootsFlag = false
    store.state.closureFlag = true
  }, 1500)
}
Vue.prototype.$tootsSuccess = function (msg) {
  store.state.tootsSuccessTxt = msg
  store.state.tootsSuccessFlag = true
  store.state.loadingFlag = false
  setTimeout(() => {
    store.state.tootsSuccessFlag = false
    store.state.closureFlag = true
  }, 1500)
}
/**
 * 判断是否微信打开来配置微信config
 */
Vue.prototype.$isWeixin = function () {
  var ua = navigator.userAgent.toLowerCase()
  var isWeixin = ua.indexOf("micromessenger") != -1
  if (isWeixin) {
    return true
  } else {
    return false
  }
}
Vue.prototype.$wxConfig = function (doctorId) {
  if (Vue.prototype.$isWeixin()) {
    return new Promise((success, error) => {
      this.$http
        .get(`/wechat/wxJsSDK?doctorId=${doctorId || localStorage.getItem("doctorId") || '1263309689931636737'}`, {
          params: {
            url: location.href,
          }
        })
        .then(res => {
          store.state.wxConfigFlag = true
          let list = res.data.data
          this.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: list.appId, // 必填，公众号的唯一标识
            timestamp: list.timestamp, // 必填，生成签名的时间戳
            nonceStr: list.nonceStr, // 必填，生成签名的随机串
            signature: list.signature, // 必填，签名
            jsApiList: [
              "chooseWXPay",
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
              "onMenuShareWeibo",
              "scanQRCode",
              "previewImage"
            ] // 必填，需要使用的JS接口列表
          })
          success()
        }).catch(err => {
          this.$toots("系统正在升级，请稍后")
        })
      this.wx.ready(() => {
        this.$wxShare()
      })
    })
  } else {
    return false
  }
}
Vue.prototype.$wxShare = function () {
  let doctorId = localStorage.getItem("doctorId")
  let productTypeId = localStorage.getItem("productTypeId")
  let link = `https://m.ibnsina360.com/#/operationProcess?doctorId=${doctorId}&productTypeId=${productTypeId}`
  this.wx.onMenuShareAppMessage({
    title: `阿维森纳健康`, // 分享标题
    desc: `专注妇产生殖疑难杂症，帮助百万家庭拥有健康宝宝`, // 分享描述
    link: `${link}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: `https://m.ibnsina360.com/logo-share.png` // 分享图标
  })
  // 分享朋友圈
  this.wx.onMenuShareTimeline({
    title: `阿维森纳健康`, // 分享标题
    link: `${link}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: `https://m.ibnsina360.com/logo-share.png` // 分享图标
  })
  // 分享微博
  this.wx.onMenuShareWeibo({
    title: `阿维森纳健康`, // 分享标题
    desc: `专注妇产生殖疑难杂症，帮助百万家庭拥有健康宝宝`, // 分享描述
    link: `${link}`, // 分享链接
    imgUrl: `https://m.ibnsina360.com/logo-share.png` // 分享图标
  })
}

/**
 * 去到登录页
 */
Vue.prototype.$goLogin = function () {
  localStorage.setItem("redirect", location.hash.slice(1))
  localStorage.removeItem("userInfo")
  this.$router.replace({
    name: "Login",
    query: {
      openId: "wxOpenId",
      doctorId: localStorage.getItem("doctorId") || "1276754304143659010",
    }
  })
}
/**
 * 根据产品id跳转到产品详情页
 */
Vue.prototype.$goProductDetails = function (id, productId) {
  this.$router.push({
    name: "ProductDetails",
    query: {
      id: id,
      productId: productId,
      doctorId: localStorage.getItem("doctorId")
    }
  })
}
Vue.prototype.$getShoppingNumber = function () {
  let userId = JSON.parse(localStorage.getItem("userInfo")).id
  this.$http
    .get(`/shoppingCart/getUserCount/${userId}`)
    .then(res => {
      if (res.data.code == 200)
        this.$store.state.shoppingCartNumber = res.data.data
    })
}
Vue.prototype.$bindBox = function (subOrderNo, barCode, type) {
  this.$loading("绑定中")
  this.$http
    .get(`/detectBox/getByBarCode/${barCode}`)
    .then(res => {
      if (res.data.code == 200) {
        this.$store.state.closureFlag = true
        let barCodeInfo = res.data.data
        if (barCodeInfo) {
          if (!barCodeInfo.subOrderNo) {
            if (type == 2) {
              // 判断是线下就跳转到绑定产品的页面
              this.$router.replace({
                name: "bindingProductList",
                query: {
                  barCode: barCode
                }
              })
              return
            }
            if (!subOrderNo) {
              this.$toots("条码号错误，请确认")
              return
            }
            barCodeInfo.subOrderNo = subOrderNo
            let list = []
            if (localStorage.getItem("bindingUserInfoList"))
              list = JSON.parse(localStorage.getItem("bindingUserInfoList"))
            for (let i = 0; i < list.length; i++) {
              if (list[i].barCode == barCodeInfo.barCode) {
                this.$router.replace({
                  name: "bindingUserInfoList",
                  query: {
                    subOrderNo: subOrderNo
                  }
                })
                return
              }
            }
            list.push(barCodeInfo)
            localStorage.setItem("bindingUserInfoList", JSON.stringify(list))
            this.$router.push({
              name: "bindingUserInfoList",
              query: {
                subOrderNo: subOrderNo
              }
            })
          } else this.$toots("当前条码号已经绑定，请确认信息")
        } else this.$toots("未查询到信息，请确认信息")
      } else this.$toots(res.data.msg)
    })
    .catch(err => {
      this.$toots("系统正在升级，请稍后")
    })
}
Vue.prototype.$nurseBindBox = function (barCode) {
  this.$loading("绑定中")
  this.$http
    .get(`/detectBox/getByBarCode/${barCode}`)
    .then(res => {
      if (res.data.code == 200) {
        this.$store.state.closureFlag = true
        let barCodeInfo = res.data.data
        if (barCodeInfo) {
          if (barCodeInfo.subOrderNo) {
            let list = []
            if (localStorage.getItem("nurseBindingUserInfoList"))
              try {
                list = JSON.parse(localStorage.getItem("nurseBindingUserInfoList"))
              } catch (err) { }
            for (let i = 0; i < list.length; i++) {
              if (list[i].barCode == barCodeInfo.barCode) {
                this.$router.replace({
                  name: "nurseBindingUserInfoList"
                })
                return
              }
            }
            list.push(barCodeInfo)
            localStorage.setItem("nurseBindingUserInfoList", JSON.stringify(list))
            if (list.length > 0)
              this.$router.replace({
                name: "nurseBindingUserInfoList"
              })
            else
              this.$router.push({
                name: "nurseBindingUserInfoList"
              })
          } else this.$toots("当前条码号未绑定，请确认信息")
        } else this.$toots("未查询到信息，请确认信息")
      } else this.$toots(res.data.msg)
    })
    .catch(err => {
      this.$toots("系统正在升级，请稍后")
    })
}
// 根据医生 id 查询渠道，再根据渠道 id 查询折扣
Vue.prototype.getDiscount = async function (doctorId) {
  if (localStorage.getItem("doctorId")) {
    let doctorId = localStorage.getItem("doctorId")
    let res = await this.$http.get(`/employee/baseControllerGetById/${doctorId}`)
    this.$http.get(`/channel/baseControllerGetById/${res.data.data.channelId}`).then(res2 => {
      this.$store.state.discount = res2.data.data.discountRate || 100
    })
  }
}

// 所有的价格位置，计算折扣价格
Vue.prototype.calculationDiscount = function (price) {
  let str = (price * this.$store.state.discount) / 100
  if (String(str).indexOf('.') != -1) {
    str = Number(str.toFixed(2))
  }
  return str
}
Vue.filter('evaluateTime', function (time) {
  var data = new Date(time)
  return `${data.getFullYear()}.${data.getMonth() + 1}.${data.getDate()}`
})
Vue.prototype.$evaluateTime = function (time) {
  var data = new Date(time)
  return `${data.getFullYear()}.${data.getMonth() + 1}.${data.getDate()} ${data.getHours()}:${data.getMinutes()}:${data.getSeconds()}`
}
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")